import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

type WaterfallCardProps = {
    readonly rank: number;
    readonly logo: ReactNode;
    readonly content: ReactNode;
    readonly action: ReactNode;
    readonly opacity?: number;
    readonly dataAutomation?: string;
};

export const WaterfallCard = ({ rank, logo, content, action, opacity = 1, dataAutomation }: WaterfallCardProps) => (
    <Flex
        alignItems="center"
        gap="10px"
        padding="16px"
        border={`1px solid ${colorsPalettes.carbon[50]}`}
        borderRadius="8px"
        background={colorsPalettes.carbon[0]}
        opacity={opacity}
        data-automation={dataAutomation}
    >
        <Flex
            width="32px"
            height="32px"
            borderRadius="50%"
            background={colorsPalettes.indigo[100]}
            flexShrink="0"
            alignItems="center"
            justifyContent="center"
        >
            <Text
                fontVariant="button"
                color={colorsPalettes.indigo[500]}
            >
                {rank}
            </Text>
        </Flex>
        <Box flexShrink="0">{logo}</Box>
        {content}
        <Box flexShrink="0">{action}</Box>
    </Flex>
);
